/*global
    jQuery
*/
(function ($) {

    // accordian for definition lists

    'use strict';

    var reveal = function() {
        var $this = $(this),
            $dd = $this.next(),
            $all = $dd.siblings('dd, dt'),
            isClosed = $dd.hasClass('closed');

        $all.addClass('closed');

        if (isClosed) {
            $this.removeClass('closed');
            $dd.removeClass('closed');
            if(!$this.parents('dl').hasClass('no-scroll')) {
                $('html, body').animate({
                    scrollTop: $this.offset().top
                }, 500);
            }
            return;
        }

        $this.addClass('closed');
        $dd.addClass('closed');
    };

    $('dt').on('click', reveal);

    $('.guidance-button').on('click', function(){
       $('.guidance').toggleClass('open');
    });

    //open when hash is found in url
    var hash = window.location.hash;
    $(hash).trigger('click');

}(jQuery));
